import { useTypedQuery } from "hooks/useTypedQuery";
import { useLocationLicensesDashboardFilters } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

export const useItemsQuery = () => {
  const { location: selectedLocation } = useLocationLicensesDashboardFilters();

  const { data, isLoading } = useTypedQuery({
    queryKey: LocationLicenseOverviewKeys.items,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.items,
    enabled: Boolean(selectedLocation?.id)
  });

  return {
    items: data || [],
    isLoadingItems: isLoading
  };
};
